/* =========================

  finish btn

============================ */
import styled from "styled-components";
import {break_point_sp} from "../../../Styled/mixin";
import {opacity_default} from "../../../Styled/mixin";


/* -------------------------

  component

---------------------------- */
function BtnFinish( props ) {
  return (
    <>
      <div className="c-btn_finish">
        <StyledInput type="submit" name="submit" id={props.id} autoComplete="off" />
        <StyledLabel htmlFor={props.id} ><span className="c-btn_finish__inner c-font_f--km">{props.children}</span></StyledLabel>
      </div>
    </>
  );
}

export default BtnFinish;

/* -------------------------

  styled

---------------------------- */
const StyledInput = styled.input`
  display: none;
`;

const StyledLabel = styled.label`
  position: relative;
  display: block;
  width: 420px;
  padding: 15px 10px;
  background-color: #ee7300;
  border-radius: 50vw;
  color: #ffffff;
  font-size: 2.8rem;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  &:hover{
    ${opacity_default}
  }
  &::after {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 32px;
    z-index: 2;
    content: "";
    display: block;
    width: 33px;
    height: 32px;
    background-image: url(${process.env.PUBLIC_URL}/assets/img/top/c-btn_finish-img01.png);
    background-size: 100% auto;
  }

	@media ${break_point_sp} {
    position: relative;
    display: block;
    width: 100%;
    padding: 15px 10px;
    background-color: #ee7300;
    border-radius: 50vw;
    color: #ffffff;
    font-size: 2.8rem;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    &:hover{
      ${opacity_default}
    }
    &::after {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 32px;
      z-index: 2;
      content: "";
      display: block;
      width: 33px;
      height: 32px;
      background-image: url(${process.env.PUBLIC_URL}/assets/img/top/c-btn_finish-img01.png);
      background-size: 100% auto;
    }
	}
`;
